export const encodeState = (redirectUrl: string) => {
  return btoa(
    JSON.stringify({
      redirectUrl,
    })
  );
};

export const decodeState = (state: string) => {
  return JSON.parse(atob(state));
};

export const installationUrl = () => {
  // Create state object with current path and origin
  const stateObj = {
    redirectUrl: window.location.pathname,
    origin: window.location.origin,
  };

  // Encode state properly
  const state = btoa(JSON.stringify(stateObj));

  // Use URLSearchParams correctly to avoid URL encoding issues
  const params = new URLSearchParams();
  params.set('state', state);

  return `https://github.com/apps/${import.meta.env.VITE_GH_APP_NAME}/installations/new?${params.toString()}`;
};

export const installationSettingsUrl = (installationId: number) =>
  `https://github.com/settings/installations/${installationId}`;
